import { useQuery } from "@apollo/client";
import ReactApexChart from "react-apexcharts";
import { GET_ANNUAL_DATA } from "../../../../queries";
import animetionLogo from "../../../../assets/utils/images/animetion_logo.gif";
import { el } from "date-fns/locale";

const Mixed = ({ orgId }) => {
  /**
   * 収入の経年変化グラフ
   */
  const { loading, error, data, refetch } = useQuery(GET_ANNUAL_DATA, {
    variables: { orgPk: orgId },
  });

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) return "...Return";
  if (!data) return "...Not Found";

  const getValue = (val, array) => {
    if (val === undefined) {
      val = "1";
    } else {
    }
    array.push(val);
  };

  const org_revenue = data && data.allAnnualData && data.allAnnualData.edges;

  //横軸
  const horizontalAxis = [];
  org_revenue.map((array) => horizontalAxis.push(array.node.fiscalYear));

  //会費
  const memberFee = [];
  org_revenue.map((array) =>
    getValue(array.node.memberFee.replace(/,/g, ""), memberFee)
  );

  //寄付金
  const donation = [];
  org_revenue.map((array) =>
    getValue(array.node.donation.replace(/,/g, ""), donation)
  );

  // 自主事業
  const businessRevenue = [];
  org_revenue.map((array) =>
    getValue(array.node.businessRevenue.replace(/,/g, ""), businessRevenue)
  );
  // # 受託事業
  const trusteeRevenue = [];
  org_revenue.map((array) =>
    getValue(
      array.node.trusteeRevenue && array.node.trusteeRevenue.replace(/,/g, ""),
      trusteeRevenue
    )
  );
  // # 助成金
  const subsidy = [];
  org_revenue.map((array) =>
    getValue(array.node.subsidy.replace(/,/g, ""), subsidy)
  );
  // # 補助金
  const bounty = [];
  org_revenue.map((array) =>
    getValue(array.node.bounty.replace(/,/g, ""), bounty)
  );

  //助成・補助金
  let government = [];

  org_revenue.map((array) =>
    getValue(
      parseInt(array.node.subsidy.replace(/,/g, "")) +
        parseInt(array.node.bounty.replace(/,/g, "")),
      government
    )
  );

  //その他収益
  const miscellaneous = [];
  org_revenue.map((array) =>
    getValue(array.node.miscellaneous.replace(/,/g, ""), miscellaneous)
  );

  const dataSeries = [
    {
      name: "会費",
      data: memberFee,
    },
    {
      name: "寄付金",
      data: donation,
    },
    {
      name: "自主事業",
      data: businessRevenue,
    },
    {
      name: "受託事業",
      data: trusteeRevenue,
    },
    {
      name: "助成金",
      data: subsidy,
    },
    {
      name: "補助金",
      data: bounty,
    },
    {
      name: "その他収益",
      data: miscellaneous,
    },
  ];

  //グラフオプション
  const dataOptions = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
      // zoom: {
      //   enabled: true,
      // },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    dataLabels: {
      enabled: false,
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#304758"],
      },
    },
    colors: [
      "#e0f9ab",
      "#69d2ceb3",
      "#47a9f3c4",
      "#ffcb2db0",
      "#f49323b5",
      "#ffbbca",
      "#53599ab3",
    ],
    xaxis: {
      categories: horizontalAxis,
    },
    yaxis: {
      labels: {
        formatter(value) {
          return value.toLocaleString();
        },
      },
    },
    legend: {
      position: "right",
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
  };

  return (
    <>
      <div id="chart">
        <ReactApexChart
          options={dataOptions}
          series={dataSeries}
          type="bar"
          height={350}
        />
      </div>
    </>
  );
};

export default Mixed;
